
export default function SwitchButton({
    isActive = false,
    onEnable = () => {},
    onDisable = () => {},
    disabled = false,
    activeText = "Enable",
    inactiveText = "Disable",
    id = "",
    className = "",
}) {

    function handleClick() {
        if (disabled) return;
        if (isActive) onDisable();
            else onEnable();
        }
    return (
        <button
            id={id}
            type="button"
            className={`btn--switch ${isActive ? "active" : ""} ${disabled ? "disabled" : ""} ${className}`}
            onClick={handleClick}
            disabled={disabled}
        >
            {/* Texte */}
            <span className="btn--switch--text">{isActive ? activeText : inactiveText}</span>
            <span className="btn--switch--handle"></span>

            {/* Switch visuel 
            <span className={`switch ${isActive ? "active" : ""}`}>
                <span className="switch-handle"></span>
            </span>*/}
        </button>
    )
}
